import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { AppConfigService } from '@tmhcc-ng-lib/global-services';
import { BaseDataService } from './base-data-service';
import { UploadDocResponse } from './def/upload-doc';
import {
  AgencyBillingResponse,
  InstallmentBillingResponse,
  InstallmentBillingAcceptStatusRequest,
  InstallmentBillingAcceptStatusResponse,
  PremiumFinancingResponse,
  QueryStringRequest,
  RedirectInstallmentBillingResponse,
  RedirectPremiumFinancingResponse,
  SaveSignatureMethodRequest,
  StepRequest
} from './def/steps';
import { GlobalVariablesService } from './global-variables.service';

@Injectable({
  providedIn: 'root'
})
export class BillingService extends BaseDataService {
  constructor(
    protected http: HttpClient,
    protected configService: AppConfigService,
    protected globalVariables: GlobalVariablesService
  ) {
    super(http, configService, globalVariables);
  }

  purchaseAgencyBilling(
    params: StepRequest
  ): Observable<AgencyBillingResponse> {
    const url = `${this.serviceBaseUrl}/billing/purchase-agency-bill/${params.policyId}/${params.versionNum}`;
    return this.post<AgencyBillingResponse>(url);
  }

  purchaseInstallmentBilling(
    params: QueryStringRequest
  ): Observable<InstallmentBillingResponse> {
    const url = `${this.serviceBaseUrl}/billing/purchase-installment-bill`;
    return this.post<InstallmentBillingResponse>(url, { body: params });
  }

  purchasePremiumFinancingBilling(
    params: QueryStringRequest
  ): Observable<PremiumFinancingResponse> {
    const url = `${this.serviceBaseUrl}/billing/purchase-premium-financing`;
    return this.post<PremiumFinancingResponse>(url, { body: params });
  }

  redirectInstallmentBill(
    params: StepRequest
  ): Observable<RedirectInstallmentBillingResponse> {
    const url = `${this.serviceBaseUrl}/billing/redirect-installment-bill/${params.policyId}/${params.versionNum}`;
    return this.post<RedirectInstallmentBillingResponse>(url);
  }

  redirectPaperlessPremiumFinancing(
    params: StepRequest
  ): Observable<RedirectPremiumFinancingResponse> {
    const url = `${this.serviceBaseUrl}/billing/redirect-premium-financing/${params.policyId}/${params.versionNum}`;
    return this.post<RedirectPremiumFinancingResponse>(url);
  }

  saveSignatureMethod(
    params: SaveSignatureMethodRequest
  ): Observable<AgencyBillingResponse> {
    const url = `${this.serviceBaseUrl}/billing/save-signature-method`;
    return this.post<AgencyBillingResponse>(url, { body: params });
  }

  getInstallmentBillingAcceptStatus(
    params: InstallmentBillingAcceptStatusRequest
  ): Observable<InstallmentBillingAcceptStatusResponse> {
    const url = `${this.serviceBaseUrl}/billing/get-installment-billing-accept-status/${params.policyId}/${params.versionNum}`;
    return this.get<InstallmentBillingAcceptStatusResponse>(url);
  }
}
